module.exports = __webpack_public_path__ + "static/img/3366_phase_function_Paper_PointsHejduk_Prediction.0b3e1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3366_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BaTL
// module chunks = 0